import React, { FC } from 'react';

interface Props {
    core: string;
    secondary?: string;
    purpose: string;
    appointment: string;
}

const DocumentTitle: FC<Props> = ({core, secondary, purpose, appointment}) => {
    return(
        <>
        {secondary? 
         <div className="dreamhome-main-title base-color">
                {core} Management <span> &middot;</span> {secondary} Management
        </div>:<div className="dreamhome-main-title base-color">{core} Management</div>}
            <div>

            </div>
            <div className="active-create-container">
            <div>
                    {purpose} {appointment}
            </div>
                
            </div>
        </>
    )
}

export default DocumentTitle